export const formatTime = (hundredths) => {
    if (isNaN(hundredths) || hundredths < 0) {
      return "00:00.00"; // Fallback for invalid values
    }
  
    const totalSeconds = Math.floor(hundredths / 100);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const hundredthsPart = hundredths % 100;
  
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedSeconds = seconds.toString().padStart(2, "0");
    const formattedHundredths = hundredthsPart.toString().padStart(2, "0");
  
    return `${formattedMinutes}:${formattedSeconds}.${formattedHundredths}`;
  };
  